const actionType = {
    GET_ADJUSTMENT_CONFIGURATION_SUCCESS: 'GET_ADJUSTMENT_CONFIGURATION_SUCCESS',
    GET_ADJUSTMENT_CONFIGURATION_FAILURE: 'GET_ADJUSTMENT_CONFIGURATION_FAILURE',
    GET_WORKFLOW_RULE_NAME_RULE_SUCCESS: 'GET_WORKFLOW_RULE_NAME_RULE_SUCCESS',
    GET_WORKFLOW_CONFIGURATION_SUCCESS: 'GET_WORKFLOW_CONFIGURATION_SUCCESS',
    GET_WORKFLOW_CONFIGURATION_BY_RECON_SUCCESS: 'GET_WORKFLOW_CONFIGURATION_BY_RECON_SUCCESS',
    CLEAR_WORKFLOW_CONFIGURATION_BY_RECON: 'CLEAR_WORKFLOW_CONFIGURATION_BY_RECON',
    SET_RECON_COLUMN_FIELDS: 'SET_RECON_COLUMN_FIELDS',
    GET_SERVER_FOLDERS: 'GET_SERVER_FOLDERS',
    GET_ALL_REPORTS_WORKFLOW: 'GET_ALL_REPORTS_WORKFLOW',
    SET_DB_COLUMNS: 'SET_DB_COLUMNS',
    SET_AUTO_MAP: 'SET_AUTO_MAP',
    GET_FILE_TEMPLATES: 'GET_FILE_TEMPLATES',
};
export default actionType;
